import {
    CLOSE_ITEMS_LIST_TEXTAREA_EDITOR,
    ItemsListTextareaEditorAction,
    OPEN_ITEMS_LIST_TEXTAREA_EDITOR,
    UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_ERRORS,
    UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_INPUT
} from '../../actions/itemsListTextareaEditor';
import { getDefaultItemsListTextareaEditorState } from '../../service/ItemsListTextareaEditor/itemsListTextareaEditor';
import { ItemsListTextareaEditorsState } from '../../typings/itemsListTextareaEditorState';
import { State } from '../../typings/state';

export function itemsListTextareaEditor(
    state: ItemsListTextareaEditorsState = {},
    action: ItemsListTextareaEditorAction,
    fullState: State
): ItemsListTextareaEditorsState {
    switch (action.type) {
        case OPEN_ITEMS_LIST_TEXTAREA_EDITOR: {
            const editorId = action.editorId;
            const editorState = state[editorId] || getDefaultItemsListTextareaEditorState();

            return {
                ...state,
                [editorId]: {
                    ...editorState,
                    value: action.value,
                    isVisible: true
                }
            };
        }

        case CLOSE_ITEMS_LIST_TEXTAREA_EDITOR: {
            const editorId = action.editorId;

            return {
                ...state,
                [editorId]: getDefaultItemsListTextareaEditorState()
            };
        }

        case UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_INPUT: {
            const { editorId, value, shouldClearInputErrors } = action;
            const editorState = state[editorId] || getDefaultItemsListTextareaEditorState();
            const errors = shouldClearInputErrors ? [] : state[editorId].errors;

            return {
                ...state,
                [editorId]: {
                    ...editorState,
                    value,
                    errors
                }
            };
        }

        case UPDATE_ITEMS_LIST_TEXTAREA_EDITOR_ERRORS: {
            const editorId = action.editorId;
            const editorState = state[editorId] || getDefaultItemsListTextareaEditorState();

            return {
                ...state,
                [editorId]: {
                    ...editorState,
                    errors: action.errors
                }
            };
        }

        default:
            return state;
    }
}
